// @ts-expect-error module not typed
import { provideThreadView } from 'conversations-thread-view/thread-view/decorators/provideThreadView';
import { PANTERA } from 'HubStyleTokens/colors';
import UIModal from 'UIComponents/dialog/UIModal';
import styled from 'styled-components';
import { useLayoutEffect, useRef } from 'react';
import { usePopOutEditorState } from '../hooks/usePopOutEditorState';
import { useIsPopOutUngated } from '../hooks/useIsPopOutUngated';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledUIModal = styled(UIModal).withConfig({
  displayName: "EditorModal__StyledUIModal",
  componentId: "gt41ku-0"
})([".popout-editor-teleporter{padding:6em 16em;position:relative;width:100%;height:100%;display:flex;flex-direction:column;color:", ";}"], PANTERA);
const _EditorModal = ({
  editorKey = 'default'
}) => {
  const targetRef = useRef(null);
  const {
    isOpen,
    key,
    setRef
  } = usePopOutEditorState(editorKey);
  const isUngated = useIsPopOutUngated();
  useLayoutEffect(() => {
    const shouldUpdateRef = isUngated && isOpen && key === editorKey;
    if (shouldUpdateRef) {
      setRef(targetRef.current);
    }
    return () => {
      if (shouldUpdateRef) setRef(null);
    };
  }, [isOpen, setRef, key, editorKey, isUngated]);
  if (isUngated && isOpen) {
    return /*#__PURE__*/_jsx(StyledUIModal, {
      use: "lightbox",
      children: /*#__PURE__*/_jsx("div", {
        ref: targetRef
      })
    });
  } else {
    return null;
  }
};
_EditorModal.displayName = 'EditorModal';
export const EditorModal = provideThreadView(_EditorModal);